import { Link } from 'react-router-dom';
import { hotManga } from '@/mocks/manga';
import MangaCard from '@/components/base/MangaCard';

export default function HotManga() {
  const displayManga = hotManga.slice(0, 10);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6" aria-label="热门漫画" data-product-shop>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">大家都在看的漫画</p>
        </div>
        <Link
          to="/category/all"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          查看更多
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-xs"></i>
          </span>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
        {displayManga.map((manga) => (
          <MangaCard
            key={manga.id}
            id={manga.id}
            slug={manga.slug}
            title={manga.title}
            coverImage={manga.coverImage}
            status={manga.status}
            category={manga.category}
            rating={manga.rating}
            updatedAt={manga.updatedAt}
            rank={manga.rank}
            chapterCount={manga.chapters.length}
          />
        ))}
      </div>
    </section>
  );
}